// extracted by mini-css-extract-plugin
export default {"columnStyle":"CJOjs7"};